'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TraceTypePieIcon = function TraceTypePieIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 46 46' }, props),
        _react2.default.createElement('path', { fill: 'none', d: 'M0 0h46v46H0z' }),
        _react2.default.createElement('path', { d: 'M23 23l-10.725 8.999A14 14 0 0 0 37 23z', fill: '#1d9bfb' }),
        _react2.default.createElement('path', { d: 'M23 23h14A14 14 0 0 0 25.431 9.213zm0 0H9a14 14 0 0 0 3.275 8.999zm0 0l2.431 13.787A14 14 0 0 0 32 33.725z', fill: '#25fdfc' }),
        _react2.default.createElement('path', { d: 'M23 23l2.431-13.787A14 14 0 0 0 9 23z', fill: '#1d9bfb' }),
        _react2.default.createElement('circle', { cx: '23', cy: '23', r: '6', fill: '#fff' })
    );
};

exports.default = TraceTypePieIcon;